import { render } from "./configFormulaComponent.vue?vue&type=template&id=1b2735fc&scoped=true"
import script from "./configFormulaComponent.vue?vue&type=script&lang=js"
export * from "./configFormulaComponent.vue?vue&type=script&lang=js"

import "./configFormulaComponent.vue?vue&type=style&index=0&id=1b2735fc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2735fc"]])

export default __exports__